import { SanitizationOption } from 'app/utils/htmlSanitizer/types';
import {
  dataLinkedConversationIdAttribute,
  transformConversationLinkElement,
} from 'components/conversation/conversationTimelineDetails/utils/linkInternalNote';
import { dataUserIdAttribute } from 'components/editorMentions';

import { SANITIZE_PROFILE_EMAIL } from './email';

export const SANITIZE_PROFILE_NOTE: SanitizationOption = {
  allowedTags: SANITIZE_PROFILE_EMAIL.allowedTags,
  allowedAttributes: {
    ...SANITIZE_PROFILE_EMAIL.allowedAttributes,
    span: [dataUserIdAttribute, dataLinkedConversationIdAttribute],
  },
  allowedSchemes: SANITIZE_PROFILE_EMAIL.allowedSchemes,
  exclusiveFilter: SANITIZE_PROFILE_EMAIL.exclusiveFilter,
  transformTags: {
    ...SANITIZE_PROFILE_EMAIL.transformTags,
    span: transformConversationLinkElement,
  },
};
